import { render, staticRenderFns } from "./LongCardPreloader.vue?vue&type=template&id=b0b15628"
import script from "./LongCardPreloader.vue?vue&type=script&lang=js"
export * from "./LongCardPreloader.vue?vue&type=script&lang=js"
import style0 from "./LongCardPreloader.vue?vue&type=style&index=0&id=b0b15628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports